import { useEffect } from "react";

export function useClipboardBlock() {
    useEffect(() => {

        const prevent = (e) => {
            e.preventDefault();
        };

        document.addEventListener("copy", prevent);
        document.addEventListener("cut", prevent);
        document.addEventListener("paste", prevent);

        return () => {
            document.removeEventListener("copy", prevent);
            document.removeEventListener("cut", prevent);
            document.removeEventListener("paste", prevent);
        };
    }, []);

    useEffect(() => {
        const handler = (e) => {

            if (e.ctrlKey || e.metaKey) {

                const key = e.key.toLowerCase();

                if (
                    ["c", "v", "x", "a", "p", "s"].includes(key)
                ) {

                    e.preventDefault();

                }

            }

        };

        window.addEventListener("keydown", handler);

        return () => window.removeEventListener("keydown", handler);

    }, []);

    useEffect(() => {

        const handler = (e) => {
            e.preventDefault();
        };

        document.addEventListener(
            "contextmenu",
            handler
        );

        return () => {
            document.removeEventListener(
                "contextmenu",
                handler
            );
        };

    }, []);

    useEffect(() => {

        const handler = (e) => {
            e.preventDefault();
        };

        document.addEventListener("dragstart", handler);

        return () => {
            document.removeEventListener(
                "dragstart",
                handler
            );
        };

    }, []);


}